/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminOrgMatchDataResponse,
  AdminOrgTeamMatchDataResponse,
  AdminOrganizationsResponse,
  GetOrganizationMatchDataParams,
  GetOrganizationProjectsParams,
  GetOrganizationProjectsResponse,
  GetOrganizationTeamMatchDataParams,
  GetOrganizationsParams,
  HTTPValidationError,
  ReviewOrgData,
  SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest,
  UpdateOrganizationRequest,
} from './platformapi.schemas';

import getOrganizationsMutator from '../custom-axios-instance';
import getOrganizationMatchDataMutator from '../custom-axios-instance';
import getOrganizationTeamMatchDataMutator from '../custom-axios-instance';
import getReviewDataMutator from '../custom-axios-instance';
import getOrganizationProjectsMutator from '../custom-axios-instance';
import updateOrganizationMutator from '../custom-axios-instance';
import updateOrganizationApplicationStatusMutator from '../custom-axios-instance';

/**
 * Get all organizations
 * @summary Get Organizations
 */
export const getOrganizations = (params: GetOrganizationsParams, signal?: AbortSignal) => {
  return getOrganizationsMutator<AdminOrganizationsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationsQueryKey = (params: GetOrganizationsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) =>
    getOrganizations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>;
export type GetOrganizationsQueryError = void | HTTPValidationError;

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organizations
 */

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Organization Match Data
 */
export const getOrganizationMatchData = (
  params: GetOrganizationMatchDataParams,
  signal?: AbortSignal,
) => {
  return getOrganizationMatchDataMutator<AdminOrgMatchDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/matching`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationMatchDataQueryKey = (params: GetOrganizationMatchDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/matching`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationMatchDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMatchData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationMatchDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationMatchData>>> = ({
    signal,
  }) => getOrganizationMatchData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationMatchData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationMatchDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationMatchData>>
>;
export type GetOrganizationMatchDataQueryError = void | HTTPValidationError;

export function useGetOrganizationMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationMatchDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMatchData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMatchData>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMatchData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMatchData>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Match Data
 */

export function useGetOrganizationMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationMatchDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Organization Team Match Data
 */
export const getOrganizationTeamMatchData = (
  params: GetOrganizationTeamMatchDataParams,
  signal?: AbortSignal,
) => {
  return getOrganizationTeamMatchDataMutator<AdminOrgTeamMatchDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/matching-teams`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationTeamMatchDataQueryKey = (
  params: GetOrganizationTeamMatchDataParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/matching-teams`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationTeamMatchDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationTeamMatchDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>> = ({
    signal,
  }) => getOrganizationTeamMatchData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationTeamMatchDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationTeamMatchData>>
>;
export type GetOrganizationTeamMatchDataQueryError = void | HTTPValidationError;

export function useGetOrganizationTeamMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationTeamMatchDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTeamMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationTeamMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTeamMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationTeamMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Team Match Data
 */

export function useGetOrganizationTeamMatchData<
  TData = Awaited<ReturnType<typeof getOrganizationTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTeamMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationTeamMatchDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get organization review data
 * @summary Get Review Data
 */
export const getReviewData = (organizationId: number, signal?: AbortSignal) => {
  return getReviewDataMutator<ReviewOrgData>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/organization_review/${organizationId}`,
    method: 'GET',
    signal,
  });
};

export const getGetReviewDataQueryKey = (organizationId: number) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/organization_review/${organizationId}`,
  ] as const;
};

export const getGetReviewDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewDataQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewData>>> = ({ signal }) =>
    getReviewData(organizationId, signal);

  return { queryKey, queryFn, enabled: !!organizationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReviewDataQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewData>>>;
export type GetReviewDataQueryError = void | HTTPValidationError;

export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewData>>,
          TError,
          Awaited<ReturnType<typeof getReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewData>>,
          TError,
          Awaited<ReturnType<typeof getReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Review Data
 */

export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReviewDataQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves basic project data for given organization id
 * @summary Get Organization Projects
 */
export const getOrganizationProjects = (
  params: GetOrganizationProjectsParams,
  signal?: AbortSignal,
) => {
  return getOrganizationProjectsMutator<GetOrganizationProjectsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/projects`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationProjectsQueryKey = (params: GetOrganizationProjectsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/projects`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationProjects>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProjects>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationProjects>>> = ({
    signal,
  }) => getOrganizationProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationProjects>>
>;
export type GetOrganizationProjectsQueryError = void | HTTPValidationError;

export function useGetOrganizationProjects<
  TData = Awaited<ReturnType<typeof getOrganizationProjects>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationProjectsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProjects>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationProjects>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationProjects<
  TData = Awaited<ReturnType<typeof getOrganizationProjects>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProjects>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationProjects>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationProjects<
  TData = Awaited<ReturnType<typeof getOrganizationProjects>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Projects
 */

export function useGetOrganizationProjects<
  TData = Awaited<ReturnType<typeof getOrganizationProjects>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update organization
 * @summary Update Organization
 */
export const updateOrganization = (
  updateOrganizationRequest: UpdateOrganizationRequest,
  signal?: AbortSignal,
) => {
  return updateOrganizationMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationRequest,
    signal,
  });
};

export const getUpdateOrganizationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    { data: UpdateOrganizationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { data: UpdateOrganizationRequest },
  TContext
> => {
  const mutationKey = ['updateOrganization'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganization>>,
    { data: UpdateOrganizationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrganization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = UpdateOrganizationRequest;
export type UpdateOrganizationMutationError = void | HTTPValidationError;

/**
 * @summary Update Organization
 */
export const useUpdateOrganization = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganization>>,
      TError,
      { data: UpdateOrganizationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { data: UpdateOrganizationRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update organization application status
 * @summary Update Organization Application Status
 */
export const updateOrganizationApplicationStatus = (
  srcRoutersAdminOrganizationsUpdateApplicationStatusRequest: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest,
  signal?: AbortSignal,
) => {
  return updateOrganizationApplicationStatusMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/update_application_status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: srcRoutersAdminOrganizationsUpdateApplicationStatusRequest,
    signal,
  });
};

export const getUpdateOrganizationApplicationStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>,
    TError,
    { data: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>,
  TError,
  { data: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest },
  TContext
> => {
  const mutationKey = ['updateOrganizationApplicationStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>,
    { data: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrganizationApplicationStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationApplicationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>
>;
export type UpdateOrganizationApplicationStatusMutationBody =
  SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest;
export type UpdateOrganizationApplicationStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update Organization Application Status
 */
export const useUpdateOrganizationApplicationStatus = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>,
      TError,
      { data: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationApplicationStatus>>,
  TError,
  { data: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationApplicationStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
